"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrLandingPage = QrLandingPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var qr_apps_1 = require("../config/qr-apps");
var arrow_down_png_1 = __importDefault(require("../assets/images/arrow-down.png"));
var main_screen_2_png_1 = __importDefault(require("../assets/images/main-screen-2.png"));
var main_screen_3_png_1 = __importDefault(require("../assets/images/main-screen-3.png"));
var main_screen_png_1 = __importDefault(require("../assets/images/main-screen.png"));
function isMobileDevice() {
    return /android|iphone|ipad|ipod/i.test(navigator.userAgent);
}
function buildDeepLink(scheme) {
    if (!scheme)
        return "";
    var fullUrl = encodeURIComponent(window.location.href);
    return "".concat(scheme, "open?url=").concat(fullUrl);
}
function tryOpenApp(deepLink, onFallback) {
    if (!deepLink) {
        onFallback();
        return function () { };
    }
    var start = Date.now();
    var handleVisibilityChange = function () {
        if (document.visibilityState === "hidden")
            cleanup();
    };
    var cleanup = function () {
        clearTimeout(timer);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
    window.location.href = deepLink;
    var timer = setTimeout(function () {
        cleanup();
        if (Date.now() - start > 1500)
            return;
        if (document.visibilityState !== "hidden" && !document.hidden)
            onFallback();
    }, 800);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return cleanup;
}
function getStoreUrl(config) {
    var ua = navigator.userAgent.toLowerCase();
    if (/huawei|hmscore/i.test(ua)) {
        return config.huaweiStoreUrl;
    }
    if (/iphone|ipad|ipod/i.test(ua)) {
        return config.appStoreUrl;
    }
    // Default to Play Store (Android and everything else)
    return config.playStoreUrl;
}
var TOTAL_PAGES = 3;
function QrLandingPage(_a) {
    var _b = _a.cyprus, cyprus = _b === void 0 ? false : _b;
    var config = cyprus ? qr_apps_1.cyprusQrConfig : qr_apps_1.defaultQrConfig;
    var _c = (0, react_1.useState)(0), currentPage = _c[0], setCurrentPage = _c[1];
    var isAnimating = (0, react_1.useRef)(false);
    var animationTimer = (0, react_1.useRef)(null);
    var appOpenCleanup = (0, react_1.useRef)(null);
    var touchStartY = (0, react_1.useRef)(0);
    var touchStartX = (0, react_1.useRef)(0);
    // On page load, try to open the app (only on mobile devices)
    (0, react_1.useEffect)(function () {
        if (!isMobileDevice())
            return;
        var deepLink = buildDeepLink(config.deepLinkScheme);
        if (deepLink) {
            return tryOpenApp(deepLink, function () {
                console.log("App not installed, showing landing page");
            });
        }
    }, [config]);
    var goToPage = (0, react_1.useCallback)(function (page) {
        if (page < 0 || page >= TOTAL_PAGES || isAnimating.current)
            return;
        isAnimating.current = true;
        setCurrentPage(page);
        animationTimer.current = setTimeout(function () {
            isAnimating.current = false;
        }, 500);
    }, []);
    (0, react_1.useEffect)(function () { return function () {
        var _a;
        if (animationTimer.current)
            clearTimeout(animationTimer.current);
        (_a = appOpenCleanup.current) === null || _a === void 0 ? void 0 : _a.call(appOpenCleanup);
    }; }, []);
    // Mouse wheel navigation
    (0, react_1.useEffect)(function () {
        if (cyprus)
            return;
        var handleWheel = function (e) {
            e.preventDefault();
            if (isAnimating.current)
                return;
            if (e.deltaY > 30) {
                goToPage(currentPage + 1);
            }
            else if (e.deltaY < -30) {
                goToPage(currentPage - 1);
            }
        };
        window.addEventListener("wheel", handleWheel, { passive: false });
        return function () { return window.removeEventListener("wheel", handleWheel); };
    }, [currentPage, goToPage, cyprus]);
    // Touch swipe navigation
    (0, react_1.useEffect)(function () {
        if (cyprus)
            return;
        var handleTouchStart = function (e) {
            touchStartY.current = e.touches[0].clientY;
            touchStartX.current = e.touches[0].clientX;
        };
        var handleTouchEnd = function (e) {
            if (isAnimating.current)
                return;
            var deltaY = touchStartY.current - e.changedTouches[0].clientY;
            var deltaX = Math.abs(touchStartX.current - e.changedTouches[0].clientX);
            // Only trigger if vertical swipe is dominant and exceeds threshold
            if (Math.abs(deltaY) > 50 && Math.abs(deltaY) > deltaX) {
                if (deltaY > 0) {
                    goToPage(currentPage + 1);
                }
                else {
                    goToPage(currentPage - 1);
                }
            }
        };
        window.addEventListener("touchstart", handleTouchStart, { passive: true });
        window.addEventListener("touchend", handleTouchEnd, { passive: true });
        return function () {
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchend", handleTouchEnd);
        };
    }, [currentPage, goToPage, cyprus]);
    var handleDownloadNow = (0, react_1.useCallback)(function () {
        var _a;
        var deepLink = buildDeepLink(config.deepLinkScheme);
        (_a = appOpenCleanup.current) === null || _a === void 0 ? void 0 : _a.call(appOpenCleanup);
        appOpenCleanup.current = tryOpenApp(deepLink, function () {
            var storeUrl = getStoreUrl(config);
            if (storeUrl) {
                if (cyprus)
                    window.location.assign(storeUrl);
                else
                    window.open(storeUrl, "_blank");
            }
        });
    }, [config, cyprus]);
    var handleLearnMore = (0, react_1.useCallback)(function () {
        var url = config.learnMoreUrl;
        if (url) {
            window.open(url, "_blank");
        }
    }, [config]);
    if (cyprus) {
        return ((0, jsx_runtime_1.jsx)("main", { className: "flex min-h-svh items-center justify-center bg-[#00263a] px-6 py-12 text-white", style: { fontFamily: "Mont, sans-serif" }, children: (0, jsx_runtime_1.jsxs)("div", { className: "w-full max-w-md text-center", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-lg font-bold uppercase tracking-widest", children: "Ocean Basket Cyprus" }), (0, jsx_runtime_1.jsx)("h1", { className: "mt-8 text-4xl font-extrabold", children: "Your Ocean Basket, in your pocket." }), (0, jsx_runtime_1.jsx)("p", { className: "mt-6 text-lg", children: "Download the Ocean Basket Cyprus app, or open it if you already have it installed." }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-8 flex flex-col gap-4", children: [config.deepLinkScheme && (0, jsx_runtime_1.jsx)("button", { onClick: handleDownloadNow, className: "rounded-full bg-white px-6 py-4 font-bold text-[#00263a]", children: "Open the app" }), config.appStoreUrl && (0, jsx_runtime_1.jsx)("a", { href: config.appStoreUrl, className: "rounded-full border border-white px-6 py-4 font-bold", children: "Download on the App Store" }), config.playStoreUrl && (0, jsx_runtime_1.jsx)("a", { href: config.playStoreUrl, className: "rounded-full border border-white px-6 py-4 font-bold", children: "Get it on Google Play" }), config.huaweiStoreUrl && (0, jsx_runtime_1.jsx)("a", { href: config.huaweiStoreUrl, className: "rounded-full border border-white px-6 py-4 font-bold", children: "Explore it on AppGallery" })] }), !config.appStoreUrl && !config.playStoreUrl && !config.huaweiStoreUrl && (0, jsx_runtime_1.jsx)("p", { className: "mt-6", children: "App download links are coming soon." }), config.learnMoreUrl && (0, jsx_runtime_1.jsx)("a", { href: config.learnMoreUrl, className: "mt-8 inline-block underline", children: "Learn more" })] }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "h-svh overflow-hidden", style: { backgroundColor: "#00263a" }, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex h-svh flex-col transition-transform duration-500 ease-in-out", style: { transform: "translateY(-".concat(currentPage * 100, "svh)") }, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-svh shrink-0 items-center justify-center", children: (0, jsx_runtime_1.jsx)("img", { src: main_screen_png_1.default, alt: "Ocean Basket - You're closer to MORE! than ever before", className: "h-svh w-auto object-contain" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "relative flex h-svh shrink-0 items-center justify-center", children: [(0, jsx_runtime_1.jsx)("img", { src: main_screen_2_png_1.default, alt: "Birthday Treats and Double Points", className: "h-svh w-auto object-contain" }), (0, jsx_runtime_1.jsx)("div", { className: "absolute bottom-8 left-1/2 -translate-x-1/2", children: (0, jsx_runtime_1.jsx)("img", { src: arrow_down_png_1.default, alt: "Scroll", className: "h-10 animate-bounce" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex h-svh shrink-0 items-center justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "relative max-h-svh max-w-full", style: { aspectRatio: "4311 / 7671" }, children: [(0, jsx_runtime_1.jsx)("img", { src: main_screen_3_png_1.default, alt: "Download the app now", className: "h-svh w-auto object-contain" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleDownloadNow, className: "absolute left-[10%] right-[10%] top-[61%] h-[7%] cursor-pointer", "aria-label": "Download Now" }), (0, jsx_runtime_1.jsx)("button", { onClick: handleLearnMore, className: "absolute left-[30%] right-[30%] top-[89%] h-[5%] cursor-pointer", "aria-label": "Learn More" })] }) })] }) }));
}
